<template>
  <div class="logo" @click="backToIndex">
    <div class="image"></div>
  </div>
</template>

<script>
import EnvConfig from "@/const/configs/env.config.js";

export default {
  name: "ros-admin-header",
  data() {
    return {
      isRegister: this.$route.path.toLocaleLowerCase() === "/register",
    };
  },
  methods: {
    backToIndex: function () {
      if (this.$route.path !== "/privacy-policy") { // app 隐私协议禁止跳转
        location.href = EnvConfig.WEBSITE_DOMAIN;
      }
    },
    register: function () {
      this.$data.isRegister = true;
      this.$router.push("/register");
    },
    login: function () {
      this.$data.isRegister = false;
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  padding: 24px 0 0 40px;
  z-index: 1;
  .image {
    background: url("../assets/logo_148x32.svg") no-repeat;
    width: 148px;
    height: 32px;
    cursor: pointer;
  }

  .text {
    margin-left: 12px;
    font-size: 24px;
    color: #fff;
    white-space: nowrap;
  }
}

.button-group {
  display: flex;
  flex-wrap: nowrap;

  span {
    color: #fff;
    padding: 10px;
  }

  button {
    padding: 10px 20px;
    font-size: 16px;
    color: #fff;
    border-radius: 38px;
    border-color: #fff;
    background: transparent;
  }
}
</style>
